/**
 * Константы для анимаций в приложении
 */

// Длительности анимаций в миллисекундах
export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 250,
  SLOW: 350,
  VERY_SLOW: 500
};

// Easing функции для CSS transitions
export const ANIMATION_EASINGS = {
  EASE: 'ease',
  EASE_IN: 'ease-in',
  EASE_OUT: 'ease-out',
  EASE_IN_OUT: 'ease-in-out',
  LINEAR: 'linear'
};

// Преднастроенные анимации
export const FADE_TRANSITION = {
  name: 'fade',
  duration: ANIMATION_DURATIONS.NORMAL,
  easing: ANIMATION_EASINGS.EASE_IN_OUT
};

export const SLIDE_TRANSITION = {
  name: 'slide',
  duration: ANIMATION_DURATIONS.NORMAL,
  easing: ANIMATION_EASINGS.EASE_OUT
};

// Утилитарные функции для создания CSS transitions
export function createTransition(property, duration = ANIMATION_DURATIONS.NORMAL, easing = ANIMATION_EASINGS.EASE) {
  return `${property} ${duration}ms ${easing}`;
}

export function createMultipleTransitions(properties, duration = ANIMATION_DURATIONS.NORMAL, easing = ANIMATION_EASINGS.EASE) {
  return properties.map(prop => createTransition(prop, duration, easing)).join(', ');
}

// Экспорт по умолчанию
export default {
  ANIMATION_DURATIONS,
  ANIMATION_EASINGS,
  FADE_TRANSITION,
  SLIDE_TRANSITION,
  createTransition,
  createMultipleTransitions
}; 